"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePullPop = void 0;
// 侧拉式弹窗
var react_1 = __importStar(require("react"));
var WithErrorHandler_1 = require("../WithErrorHandler");
var smartScroll_1 = __importDefault(require("../../utils/smartScroll"));
var SidePullPop = function (_a) {
    var show = _a.show, popId = _a.popId, title = _a.title, scrollId = _a.scrollId, closeFun = _a.closeFun, children = _a.children;
    var smartScrollRef = react_1.useRef({});
    react_1.useEffect(function () {
        // console.log('slide pop', children)
        if (!scrollId) {
            return;
        }
        smartScrollRef.current = new smartScroll_1.default("#" + popId, scrollId);
        if (show) {
            smartScrollRef.current.preventScroll();
        }
        else {
            smartScrollRef.current.allowScroll();
        }
    }, [show, scrollId]);
    return (react_1.default.createElement("div", { className: "newcar_ui_sidePullPopWrap " + (show ? 'newcar_ui_moveLeft' : ''), id: popId },
        react_1.default.createElement("div", { className: 'newcar_ui_closePop', onClick: closeFun },
            react_1.default.createElement("span", null)),
        react_1.default.createElement("div", { className: 'newcar_ui_sidePullPopCon' },
            react_1.default.createElement("h4", { className: 'newcar_ui_sidePullPopTitle', hidden: !title },
                title,
                react_1.default.createElement("a", { className: 'newcar_ui_closeBtn', onClick: closeFun })),
            children)));
};
exports.SidePullPop = SidePullPop;
exports.SidePullPop.defaultProps = {
    popId: '',
    title: '',
    show: false,
    // eslint-disable-next-line no-empty-function
    closeFun: function () { },
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(exports.SidePullPop));
